import React from 'react';
import { Navigate } from 'react-router-dom';
import { compileWithArgs } from 'src/js/helper/path-to-regexp-helper';
import { useStores } from 'src/js/hook/use-stores';
import { DecoderPage } from 'src/js/pages/streaming/decoder/decoder';
import { MakitoPaths } from 'src/js/route';
import { constant } from 'src/js/constant';
import { useReadLocalStorage } from 'usehooks-ts';

import { Streams } from './stream/stream';
import { St2110Page } from './st2110/st2110';
import { StillImages } from '../settings/stillimages/stillimages';

export type StreamPageParameters = {
  page?: StreamKey;
};

export enum StreamKey {
  OUTPUTS = 'output',
  DECODERS = 'decoder',
  STREAMS = 'stream',
  STILLIMAGES = 'stillImages',
}

export const DefaultStreamsRoute: React.FunctionComponent = () => {
  const { sessionStore } = useStores();
  const selectedTab =
    useReadLocalStorage(`${constant.lStorage.streamingTab}:${sessionStore.username}`) ?? StreamKey.STREAMS;

  return (
    <Navigate
      to={compileWithArgs<StreamPageParameters>(MakitoPaths.streaming)({
        page: selectedTab as StreamKey, // show page in localstorage if a direct section access without any specific page
      })}
      replace={
        true
      } /* replace current entry in history stack instead of adding new one, thus allowing to use back button a single time to go back (as expected) instead of two */
    />
  );
};

export const StreamsRoutes: any = [
  {
    path: '',
    element: <DefaultStreamsRoute />,
  },
  /* FIXME {
    path: StreamKey.OUTPUTS,
    element: <St2110Page />,
  },*/
  {
    path: StreamKey.DECODERS,
    element: <DecoderPage />,
  },
  {
    path: StreamKey.STREAMS,
    element: <Streams />,
  },
  {
    path: StreamKey.STILLIMAGES,
    element: <StillImages />,
  },
  {
    path: StreamKey.OUTPUTS,
    element: <St2110Page />, /// FIXME only when in 2110 personality
  },
];
